export default "__VITE_ASSET__09a5c785__"